module.exports = __webpack_public_path__ + "static/media/clinician-rhythm-preview@3x.c0c00a3d.png";